import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyAXWJJAg7v06bTIxJ0ByuxUcG-oOHqjcyo",
  authDomain: "postal-a-mao-web.firebaseapp.com",
  databaseURL: "https://postal-a-mao-web.firebaseio.com",
  projectId: "postal-a-mao-web",
  storageBucket: "postal-a-mao-web.appspot.com",
  messagingSenderId: "763074677703",
  appId: "1:763074677703:web:4e451c41224bbde14de7e2",
  measurementId: "G-9M8QYZYYFT"
};
firebase.initializeApp(firebaseConfig);

// utils
const db = firebase.firestore();
const auth = firebase.auth();
const functions = firebase.functions();
const SERVER_TIME = firebase.firestore.FieldValue.serverTimestamp();
const ARRAY_UNION = firebase.firestore.FieldValue.arrayUnion;
const ARRAY_REMOVE = firebase.firestore.FieldValue.arrayRemove;

db.enablePersistence().catch(function(err) {
  console.log("fb error", err);
  if (err.code == "failed-precondition") {
    // Multiple tabs open, persistence can only be enabled
    // in one tab at a a time.
    // ...
  } else if (err.code == "unimplemented") {
    // The current browser does not support all of the
    // features required to enable persistence
    // ...
  }
});

// collection references
const usersCollection = db.collection("users");
const countriesCollection = db.collection("countries");
const settingsCollection = db.collection("settings");
const cardsCollection = db.collection("cards");
const cardDestCollection = db.collection("card_destinations");
const keysCollection = db.collection("beta_keys");

// export utils/refs
export {
  db,
  auth,
  functions,
  usersCollection,
  countriesCollection,
  settingsCollection,
  cardsCollection,
  cardDestCollection,
  keysCollection,
  SERVER_TIME,
  ARRAY_UNION,
  ARRAY_REMOVE
};
